export default String(process.env.NEXT_PUBLIC_PROJECT_GUID);
